const ProvidersKeys = {
    SOLUTIONS_DATA: "solutions_data",
    TRANSLATIONS: "translations",
    CLUSTER_CONFIG: "cluster_config",
    MANIFEST_DATA: "manifest_data",
    MONDAY_BOARD_CONFIG: "monday_board_config"
};
module.exports = ProvidersKeys;
